import { ApiResponse } from '../api';
import { axios } from '@src/lib/axios'

export type Category = 'roles'|'users'|'employees'|'api-logs'


export interface RoleDto {
  /** ID */
  uuid?: string;
  /** 代碼 */
  code: string;
  /** 描述 */
  description: string;
  /** 狀態 */
  status: string;
  /** 修改時間 */
  updatedAt?: string;
}

export interface UserDto {
  /** ID */
  uuid?: string;
  /** 帳號 */
  account: string;
  /** 密碼 */
  password?: string;
  /** 姓名 */
  name: string;
  /** 員工編號 */
  employeeNo?: string;
  /** 員工編號UUid */
  employeeUuid?: string;
  /** EMail */
  email?: string;
  /** 電話 */
  mobile?: string;
  /** 角色Uuid */
  roleUuid: string;
  /** 狀態 */
  status: string;
  /** 新增時間 */
  createdAt?: string;
}

export interface EmployeeDto {
  /** ID */
  uuid?: string;
  /** 員工編號 */
  employeeNo: string;
  /** 姓名 */
  name: string;
  /** email */
  email?: string;
  /** 電話 */
  mobile?: string;
  /** 到職日期 */
  arrivalDate: string;
  /** 狀態 */
  status: string;
  /** 新增時間 */
  createdAt?: string;
}

export interface LogDto {
  /** ID */
  uuid: string;
  /** 使用者ID */
  userUuid: string;
  /** 功能 */
  fnCode: string;
  /** 參數 */
  request: string;
  /** 新增時間 */
  createdAt: string;
}

export type SystemListDto = RoleDto[] | UserDto[] | EmployeeDto[] | LogDto[]

export type SystemDto = RoleDto | UserDto | EmployeeDto | LogDto

export interface GetItemListByCategoryReqDto {
  category: Category;
  keyword: string;
  page: number;
}

export interface GetItemListByCategoryRespDto {
  totalNumber: number;
  data: SystemListDto;
  totalPages: number;
}

/** 取得系統項目清單 */
export async function getItemListByCategory(reqDto: GetItemListByCategoryReqDto): Promise<GetItemListByCategoryRespDto> {
  const { category, page, keyword } = reqDto
  const defaultApiPath = `/api/web/system/${category}?page=${page}`
  const apiPath = keyword ? `${defaultApiPath}&keyword=${keyword}` : defaultApiPath
  const response = await axios.get<ApiResponse<GetItemListByCategoryRespDto>>(apiPath)

  return response.data
}

export interface AddItemByCategoryReqDto {
  category: Category;
  data: SystemDto;
}

/** 新增系統項目 */
export async function addItemByCategory(reqDto: AddItemByCategoryReqDto) {
  const { category, data } = reqDto

  await axios.post<ApiResponse<void>>(`/api/web/system/${category}`, data)
}

export interface GetItemByCategoryReqDto {
  category: Category;
  uuid: string;
}

export type GetItemByCategoryRespDto = SystemDto;

/** 取得系統項目 */
export async function getItemByCategroy(reqDto: GetItemByCategoryReqDto): Promise<GetItemByCategoryRespDto> {
  const { category, uuid } = reqDto

  const response = await axios.get<ApiResponse<GetItemByCategoryRespDto>>(`/api/web/system/${category}/${uuid}`)

  return response.data
}

export interface DeleteItemByCategoryReqDto {
  category: Category;
  uuid: string;
}

/** 刪除系統項目 */
export async function deleteItemByCategroy(reqDto: DeleteItemByCategoryReqDto) {
  const { category, uuid } = reqDto

  await axios.delete<ApiResponse<void>>(`/api/web/system/${category}/${uuid}`)
}

export interface UpdateItemByCategoryReqDto {
  category: Category;
  uuid: string;
  data: SystemDto;
}

/** 更新系統項目 */
export async function updateItemByCategroy(reqDto: UpdateItemByCategoryReqDto) {
  const { category, uuid, data } = reqDto

  await axios.put<ApiResponse<void>>(`/api/web/system/${category}/${uuid}`, data)
}
